// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"594":"about","606":"extension","659":"customer","806":"user","966":"login"}[chunkId] + "." + {"594":"f77311aa","606":"2a2700a9","659":"8b7d6f79","806":"a99d852c","966":"ed1168f9"}[chunkId] + ".js";
};